import React from 'react';
import { motion } from 'framer-motion';
import { Award, Calendar, Star, ShieldCheck } from 'lucide-react';
const stats = [{
  icon: Calendar,
  value: '30+',
  label: 'Years in Perth',
  sub: 'Since 1995'
}, {
  icon: Award,
  value: 'Diamond',
  label: 'Mitsubishi Dealer',
  sub: 'Accredited installer'
}, {
  icon: Star,
  value: '5.0★',
  label: '75 Google Reviews',
  sub: 'Zero one star reviews'
}, {
  icon: ShieldCheck,
  value: 'Owner',
  label: 'Quoted by Mike',
  sub: 'No subbies, no sales reps'
}];
export function TrustStrip() {
  return <section className="bg-brand text-white" aria-label="Langler Air credentials" data-id="element-780">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-781">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-id="element-782">
          {stats.map((stat, i) => {
          const Icon = stat.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="flex items-start gap-4" data-id="element-783">
                <span className="w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0" data-id="element-784">
                  <Icon size={20} strokeWidth={2} data-id="element-785" />
                </span>
                <div data-id="element-786">
                  <div className="text-3xl sm:text-4xl font-extrabold tracking-tight leading-none" data-id="element-787">
                    {stat.value}
                  </div>
                  <div className="mt-1.5 text-sm font-semibold" data-id="element-788">
                    {stat.label}
                  </div>
                  <div className="text-xs text-white/70" data-id="element-789">{stat.sub}</div>
                </div>
              </motion.div>;
        })}
        </div>

        <p className="mt-10 text-center text-sm text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-790">
          Authorised installer for Mitsubishi Electric, Daikin and Rinnai.
          Family run from Balcatta since 1995. Every quote done on site by Mike
          Spear personally.
        </p>
      </div>
    </section>;
}